<template>
  <Transition name="slide-bottom">
    <div
      v-show="show"
      id="mobile-sticky-cta-button"
      class="garage-mobile-sticky-button"
    >
      <NuxtLink :to="route.path + '/services?other-reason=true'">
        <DmButton
          has-icon="left"
          icon="i-calendar"
          title="Umów wizytę"
        />
      </NuxtLink>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { DmButton } from '@dobrymechanik/vue-ui-v2';

interface IProps {
  garagePriceListCount: number;
}

// props
const props = defineProps<IProps>();

// use 
const route = useRoute();

// data
const show: Ref<boolean> = ref(false);

// methods
const handleScroll = () => {
  const baseY = document.getElementById('services-tab');
  const tabControllerHeight = document.getElementById('tabs-controller')?.getBoundingClientRect().height || 0;
  const appFooterHeight = document.getElementById('app-footer')?.getBoundingClientRect().height || 0;
  const buffer = 300;

  if (!baseY?.offsetTop) return;
  if (
    (window.scrollY >= (baseY.offsetTop - tabControllerHeight))
    &&
    (window.scrollY + window.innerHeight + appFooterHeight + buffer < document.body.scrollHeight)
  ) {
    show.value = true;
  } else {
    show.value = false;
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});
</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-mobile-sticky-button.scss');
</style>